import { render, staticRenderFns } from "./CollapsableCardWithHeader.vue?vue&type=template&id=915a4eaa&scoped=true"
import script from "./CollapsableCardWithHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsableCardWithHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CollapsableCardWithHeader.vue?vue&type=style&index=0&id=915a4eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915a4eaa",
  null
  
)

export default component.exports